import { Source, parse } from 'graphql';

export const parseQuery = (query: string | Source) => parse(query, { noLocation: true });
